import {inject} from '@angular/core';
import {CanMatchFn} from '@angular/router';
import {StorageService} from '@kilobytelab/core';
import {UtilService} from './services/utils.service';
import {AppService} from './services/app.service';

export const appGuard: CanMatchFn = async () => {

  const utilService = inject(UtilService);
  const storage = inject(StorageService);
  const appService = inject(AppService);

  try {
    const token = await storage.getToken();
    if (!token) {
      await utilService.LOGOUT();
      return false
    }
    if (appService.ALUMNO()) return true;
    await utilService.START(token, undefined, false);
    return true
  } catch (err) {
    await utilService.LOGOUT();
    return false
  }
}